import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { useTheme } from '../context/ThemeContext';

const Layout = ({ children, activeSection, showTrivia, setShowTrivia }) => {
  const { darkMode } = useTheme();
  
  return (
    <div className={`flex flex-col min-h-screen ${darkMode ? 'dark bg-[#121212]' : 'bg-white'}`}>
      <Header />
      <main className="flex-grow pt-24 dark:text-white">
        {children}
      </main>
      <Footer 
        showTrivia={showTrivia} 
        setShowTrivia={setShowTrivia} 
      />
    </div>
  );
};

export default Layout; 